// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"700":"css/admin-app.6670","2734":"css/app.6670"}[chunkId] + ".css";
};